import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import Table from '../../components/Table';
import { useSelector } from 'react-redux';

function Forms() {
  const [forms, setForms] = useState([]);
  const [exportData, setExportData] = useState([]);
  const [openProgress, setOpenProgress] = useState(false);
  const nameProperty = useSelector((state) => state.nameProperty.nameProperty);

  const columns = [
    {
      title: 'Nome',
      field: 'name',
      hideFilterIcon: true,
    },
    {
      title: 'Parâmetros',
      editable: 'never',
      field: 'rules',
      render: (rowData) => {
        let parameters = '';
        rowData.parameters.map(
          (parameter) => (parameters += `${parameter.parameter.name}, `),
        );
        return parameters.slice(0, -2);
      },
      hideFilterIcon: true,
    },
    {
      title: 'Medição',
      field: 'type',
      hideFilterIcon: true,
      render: (rowData) => {
        if (rowData.type === 'Saúde') {
          return 'Análise de Saúde';
        } if (rowData.type === 'Animal') {
          return 'Biometria';
        } if (rowData.type === 'Água') {
          return 'Análise de Água';
        }
      },
    },
  ];

  useEffect(() => {
    async function loadData() {
      global.loading = true;
      try {
        const response = await api.get('/forms');

        if (response.data.length === 0) {
          setOpenProgress(true);
        }
        if (response.data) {
          const data = await response.data;
          const organizedData = await data.map((_form) => ({
            name: _form.name,
            rules: _form.parameters.map((_element, index) => {
              if (index === 0) {
                return _element.parameter.name;
              }
              return ` ${_element.parameter.name}`;
            }),
          }));

          setForms(data);
          setExportData(organizedData);
          setOpenProgress(true);
        }
      } catch (err) {

      }
      global.loading = false;
    }
    loadData();
  }, [nameProperty]);

  function setData(newData) {
    const tempData = [];
    forms.map((form) => (form.id === newData.id ? tempData.push(newData) : tempData.push(form)));
    setForms(tempData);
  }
  return (
    <Table
      title="Formulários"
      route="/forms/"
      routeAdd="/form/"
      columns={columns}
      data={forms}
      setData={setData}
      dataLoaded={openProgress}
      exportData={exportData}
    />
  );
}

export default Forms;
